import { render, staticRenderFns } from "./BetForm.vue?vue&type=template&id=17cafd3e&"
import script from "./BetForm.vue?vue&type=script&lang=js&"
export * from "./BetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BetForm.vue"
export default component.exports